import Vue from 'vue'
import Vuex, {Module, ModuleTree} from 'vuex'
import {IRootStateModel} from './interfaces'
import authentification from './modules/authentification'
import companies from './modules/companies'
import employees from './modules/employees'
import categories from './modules/categories'
import criterions from './modules/criterions'
import subscription from './modules/subscriptions'

Vue.use(Vuex)

const modules: ModuleTree<IRootStateModel> = {
  authentification,
  companies,
  employees,
  categories,
  criterions,
  subscription
}

const root: Module<IRootStateModel, IRootStateModel> = {
  modules
}

export default new Vuex.Store(root)
